import { render, staticRenderFns } from "./EventoCupos.vue?vue&type=template&id=67124f77&"
import script from "./EventoCupos.vue?vue&type=script&lang=js&"
export * from "./EventoCupos.vue?vue&type=script&lang=js&"
import style0 from "./EventoCupos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports